import React, { Component } from 'react'
import userManager from 'Auth/Zendesk/userManager'
import Splash from 'App/Splash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import jwtSimple from 'jwt-simple'

class Callback extends Component {
  async componentDidMount () {
    const user = await userManager.signinCallback()

    var subDomain = process.env.REACT_APP_ZENDESK_URL
    var payload = generatePayload(user)

    var redirectUrl = `${subDomain}access/jwt?jwt=${payload}&return_to=${user.state}`

    window.location.href = redirectUrl
  }

  render () {
    return <Splash text='Estamos carregando a sua experiência.' />
  }
}

const generatePayload = user => {
  var generateUUID = require('uuid')
  var payload = {
    email: user ? user.profile.email : '',
    name:
      user.profile && user.profile.name
        ? user.profile.name
        : user.profile.username,
    external_id: user ? user.profile.username : '',
    jti: generateUUID.v4(),
    iat: Math.round(new Date().getTime() / 1000)
  }
  var secret = process.env.REACT_APP_ZENDESK_SECRET
  var token = jwtSimple.encode(payload, secret)
  return token
}

const mapStateToProps = ({ oidc }) => ({
  profile: oidc.user && oidc.user.profile
})

const mapDispatchToProps = dispatch => ({
  redirectToLastLocation: user => dispatch(push(user.state))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Callback)



// WEBPACK FOOTER //
// ./src/Auth/Zendesk/Callback.js